import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import TableRow from '@mui/material/TableRow';

import { TableCell } from 'common/components/Table';
import { formatPrice } from 'common/utils/formatPrice';
import { formatDate } from 'common/utils/formatDate';
import { useGlobalDrawer } from 'common/hooks/useGlobalDrawer';
import { IGlobalDrawerType } from 'common/types';
import { useRouteMatch } from 'route/hooks/useRouteMatch';
import { getUrl } from 'route/utils/getUrl';
import {
    IBudgetRequestListItemFragment,
    IBudgetRequestStatus,
} from 'graphql/types';
import { BudgetApprovalStatusChip } from 'budget/components/BudgetApprovals/BudgetApprovalStatusChip';

interface IProps {
    budgetRequest: IBudgetRequestListItemFragment;
}

export const UserBudgetRequestsTableRow = ({ budgetRequest }: IProps) => {
    const [translate] = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const isOwnPortfolio = !!useRouteMatch('PORTFOLIO_BUDGET');
    const { openGlobalDrawer } = useGlobalDrawer();

    const { id, title, group, amount, creationDate, status } = budgetRequest;

    // Once a manager has picked it up the request can no longer be changed.
    const isPendingManager = status === IBudgetRequestStatus.PendingManager;

    const handleClick = () => {
        if (isOwnPortfolio && isPendingManager) {
            return navigate(
                `${getUrl('BUDGET_REQUEST_EDIT', {
                    budgetRequestId: id,
                })}${location.search}`
            );
        }

        openGlobalDrawer(
            { type: IGlobalDrawerType.BudgetRequest, itemId: id },
            location
        );
    };

    return (
        <TableRow hover sx={{ cursor: 'pointer' }} onClick={handleClick}>
            <TableCell>{title}</TableCell>
            <TableCell>{group?.name ?? '-'}</TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {amount
                    ? `€ ${formatPrice(amount)}`
                    : translate('userBudgetRequestsTable.free')}
            </TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {formatDate(creationDate, 'd MMMM yyyy')}
            </TableCell>
            <TableCell>
                <BudgetApprovalStatusChip status={status} />
            </TableCell>
        </TableRow>
    );
};
